import Vue from "vue";
import {ModalPlugin} from "bootstrap-vue";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
// @ts-ignore
import * as Icons from "uikit/dist/js/uikit-icons.js";
// @ts-ignore
import UIkit from "uikit";
import VueApexCharts from "vue-apexcharts";

import "@/libs/compositionApi";

// @ts-ignore
import router from "./router";
// @ts-ignore
import store from "./store";
// @ts-ignore
import App from "./app.vue";

// 3rd party plugins
// @ts-ignore
import VueI18n from "@/libs/i18n";
import "@/libs/fontAwesome";
import "@/libs/axios";
import "@/libs/portalVue";
import "@/libs/acl";
import "@/libs/clipboard";
import "@/libs/cookies";
import "@/libs/crypto";
import "@/libs/luxon";
import "@/libs/observeVisibility";
import "@/libs/vCalendar";
import "@/libs/tour";
import "@/libs/virtualScroller";
import "@/libs/vuePwaInstall";

// Auth0
// @ts-ignore
import {Auth0Plugin} from "@/auth/auth0";
import {useJwt} from "@/auth/jwt/useJwt";
// Service worker
import "@/registerServiceWorker";

// Insights
// @ts-ignore
import AddGraphPlugin from "@/views/modules/insights/plugins/show-add-graph-menu";
// @ts-ignore
import DataExtractorPlugin from "@/views/modules/insights/plugins/data-extractor";
// @ts-ignore
import DataFormatterPlugin from "@/views/modules/insights/plugins/data-formatter";
// @ts-ignore
import FormatNumberPlugin from "@/views/modules/insights/plugins/number-formatter";
// @ts-ignore
import URLBuilderPlugin from "@/views/modules/insights/plugins/url-builder";
// @ts-ignore
import OutsideClickPlugin from "@/views/modules/insights/plugins/outside-click";

// PINIA
import {createPinia, PiniaVuePlugin} from "pinia";
// VUE-QUERY
import {VueQueryPlugin} from "@tanstack/vue-query";


Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// Fake database requests
//import "@/@fake-db/db";

// Auth0
useJwt();

// BSV Plugin Registration
Vue.use(ModalPlugin);
Vue.use(PerfectScrollbar);

Vue.use(VueQueryPlugin);

Vue.use(AddGraphPlugin);
Vue.use(DataExtractorPlugin);
Vue.use(DataFormatterPlugin);
Vue.use(FormatNumberPlugin);
Vue.use(URLBuilderPlugin);
Vue.use(OutsideClickPlugin);

Vue.use(VueApexCharts);
Vue.component("apexcharts", VueApexCharts);
UIkit.use(Icons);

Vue.use(Auth0Plugin, {
    // @ts-ignore
    onRedirectCallback: (appState) => {
        router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
    },
});

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");
require("@/assets/scss/customSizes.scss");

// Saysimple icons
require("@/assets/scss/saysimpleIcons.scss");

Vue.config.productionTip = false;
Vue.config.ignoredElements = ["zapier-workflow"];

new Vue({
    i18n: VueI18n,
    // @ts-ignore
    router,
    store,
    pinia,
    render: (h) => h(App),
}).$mount("#app");
